import {Injectable} from "@angular/core";
import {HttpModelConverter} from "../../../../../../../core/converter/httpModel.converter";import {
    LovValueSummaryConverter
} from "../../../../../../../common/lov/lov-value/api/converter/LovValueSummary.converter";
import {TreatmentJourneyStepDefinitionTriggerModel} from "./treatmentJourneyStepDefinitionTrigger.model";
import {
    TreatmentJourneyStepDefinitionFeedbackModel,
    TreatmentJourneyStepDefinitionModel, TreatmentJourneyStepDefinitionReminderModel
} from "./treatmentJourneyStepDefinition.model";
import {TreatmentJourneyStepDefinitionTriggerConverter} from "./treatmentJourneyStepDefinitionTrigger.converter";
import {
    CommunicationContentModelSummaryConverter
} from "../../../../../../../communication/content-model/api/entity/converter/communicationContentModelSummary.converter";

@Injectable({
    providedIn: 'root'
})
export class TreatmentJourneyStepDefinitionConverter extends HttpModelConverter<TreatmentJourneyStepDefinitionModel> {

    constructor(private triggerConverter: TreatmentJourneyStepDefinitionTriggerConverter,
                private communicationContentModelSummaryConverter: CommunicationContentModelSummaryConverter) {
        super();
    }

    protected createInstance(): TreatmentJourneyStepDefinitionModel {
        return new TreatmentJourneyStepDefinitionModel();
    }

    protected enrichObject(result: TreatmentJourneyStepDefinitionModel, src: TreatmentJourneyStepDefinitionModel) {
        result.trigger = this.triggerConverter.convert(src.trigger);
        result.feedbacks = src.feedbacks.map(value => {
            const target = new TreatmentJourneyStepDefinitionFeedbackModel();
            target.communicationContentModel = this.communicationContentModelSummaryConverter.convert(value.communicationContentModel);
            target.trigger = this.triggerConverter.convert(value.trigger);
            target.emailSubject = value.emailSubject;
            return target;
        });
        result.reminders = src.reminders.map(value => {
            const target = new TreatmentJourneyStepDefinitionReminderModel();
            target.communicationContentModel = this.communicationContentModelSummaryConverter.convert(value.communicationContentModel);
            target.trigger = this.triggerConverter.convert(value.trigger);
            target.emailSubject = value.emailSubject;
            return target;
        });
    }


}